export default {"src":"/_next/static/media/Right.e1de0ba2.svg","height":54,"width":30,"blurWidth":0,"blurHeight":0};